import { useEffect, useRef } from 'react';

/** Run a callback at every local midnight, including DST transitions. */
export function useMidnightRefresh(onRefresh: () => void) {
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;

    const scheduleNextMidnight = () => {
      const now = new Date();
      const nextMidnight = new Date(now);
      nextMidnight.setHours(24, 0, 0, 0);
      timer = setTimeout(() => {
        onRefreshRef.current();
        scheduleNextMidnight();
      }, nextMidnight.getTime() - now.getTime());
    };

    scheduleNextMidnight();
    return () => {
      if (timer !== null) clearTimeout(timer);
    };
  }, []);
}
